import $ from 'jquery';
import Cookies from 'js-cookie';
import 'slick-carousel';
import 'rangeslider.js';
import './lib/jquery.marquee.js';
import './lib/bounce.js';

window.jQuery = window.$ = $;
window.Cookies = Cookies;

$(function(){	

	var transitionTime = 1000;

	function lazyImgsFunct(imgSmlSrc,$this,$wrap){
        var $placeholder = $('<svg class="placeholder"><filter id="svgFilter" width="100%" height="100%" x="-0%" y="-0%"><fegaussianblur id="svgGaussBlur" in="SourceGraphic" stdDeviation="10"></fegaussianblur><feComponentTransfer><feFuncA type="discrete" tableValues="1 1"/></feComponentTransfer></filter><image xlink:href="'+imgSmlSrc+'" filter="url(#svgFilter)" width="100%" height="100%" x="0" y="0" preserveAspectRatio="xMidYMid slice"></image></svg>');
		var imgLarge = new Image();
		var lrgSrc = $this[0].dataset.large;
		//var $placeholder = $wrap.find('svg.placeholder');
		var transitionEvent = whichTransitionEvent();
		var slowload = setTimeout(function(){
			$wrap.addClass('slowload');
		},3000);

		$wrap.append($placeholder);

		imgLarge.src = lrgSrc; 
	
		if (imgLarge.complete && imgLarge.naturalWidth > 0) {
			clearTimeout(slowload);	
			$this
				.attr('src',lrgSrc)
				.removeClass('lazy');
			$wrap.removeClass('slowload');
				//.find('svg.placeholder')
				// .fadeOut(300,function(){
				// 	$(this).remove();
				// });
				$placeholder
					.css({'transition':'opacity 500ms','opacity':0}).one(transitionEvent,
				        function() {
				        	$placeholder.remove();

				});				
		}else{

			imgLarge.onload = function () {
				clearTimeout(slowload);	
				$this
					.attr('src',lrgSrc)
					.removeClass('lazy');
				$wrap.removeClass('slowload');
				
				$placeholder
					.css({'transition':'opacity 500ms','opacity':0}).one(transitionEvent,
				        function() {
				        	$placeholder.remove();

				});
			};
		}		
	}
	function lazyImgs(){
		
		var $imgs = $('img.lazy');

		$imgs.each(function(){
			var $this = $(this);
			var $wrap = $this.parent();
			// var img = new Image();
			var imgSml = new Image();
			var imgSmlSrc = this.src;	
			imgSml.src = imgSmlSrc;

	        if (imgSml.complete && imgSml.naturalWidth > 0) {
	            //$this.addClass('loaded-placeholder');
	            lazyImgsFunct(imgSmlSrc,$this,$wrap);

	        }else {
	        	imgSml.onload = function () {
	        		lazyImgsFunct(imgSmlSrc,$this,$wrap);
	        	}	
	        }	
						
		});
	}
	lazyImgs();

	function marqueeLongTitle(){
		var $projectTitle = $('.single-project-title');
		if($projectTitle.length && $projectTitle[0].scrollWidth > $projectTitle.innerWidth()){
			$projectTitle.marquee({
				//duration in milliseconds of the marquee
				duration: 10000,
				//gap in pixels between the tickers
				//gap: 50,
				//time in milliseconds before the marquee will start animating
				delayBeforeStart: 0,
				//'left' or 'right'
				direction: 'left',
				//true or false - should the marquee be duplicated to show an effect of continues flow
				duplicated: true
				//startVisible:true
			});
		}
	}
	marqueeLongTitle();	


	$(document).on({
	    mouseenter: function () {
	    	var $mq = $(this).find('.project-list-title');
	    	if( 
				$mq[0].scrollWidth > ($mq.parent().innerWidth() - 20)
				&& window.innerWidth > document.getElementById('projects').offsetWidth 
	    	   ){
				$mq.marquee({
					duration: 10000,
					delayBeforeStart: 0,
					direction: 'left',
					duplicated: true,
					startVisible:true			
				});
			}	
	    },
	    mouseleave: function () {
	        $(this).find('.project-list-title').marquee('destroy');
	    }
	}, ".mq-hover-wrap"); 


	$(window).resize(function(){
		marqueeLongTitle();
		////marqueeListTitle();	
	});



	// $(document).on('click','.play-pause-video',function(){
	// 	var $wrap = $(this);
	// 	var $video = $wrap.find("video");
	// 	var $button = $wrap.find("button.play-pause");
	// 	var video = $video.get(0);
	// 	//var $seekBar = $wrap.find(".seek-bar");
	// 	if (video.paused === true) {
	// 		video.play();

	// 		// $wrap.addClass("playing hide-controls");
	// 		// $wrap.mouseleave(function(){
	// 		// 	$wrap.removeClass("hide-controls");
	// 		// });
	// 		$wrap.addClass("playing");
	// 		$button.css('opacity',0);
	// 	} else {
	// 		video.pause();
	// 		$wrap.removeClass("playing");
	// 		$button.css('opacity',1);
	// 	}

	// });	
	
	function iframesReady(){
		// Create IE + others compatible event handler
		var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
		var eventer = window[eventMethod];
		var messageEvent = eventMethod == "attachEvent" ? "onmessage" : "message";

		// Listen to message from child window
		eventer(messageEvent,function(e) {
			//window.console.log('parent received message!:  ',e.data);
			if (typeof e.data === 'string' && e.data.indexOf('http') !== -1) {
				$('iframe[src="'+e.data+'"]').closest('.videowrap').addClass('video-ready');
			}	
		},false);		
	}
	iframesReady();

	function clearTooltipOnScroll(){

		var $scrollDiv = $('.img-tooltip').closest('.content');
		$scrollDiv.each(function(){

			var $scrollDiv = $(this);
			var isScrolling;
			var tooltips = $scrollDiv.find('.img-tooltip .tip'); 

			$scrollDiv.scroll(function(){	
				// Clear our timeout throughout the scroll
				window.clearTimeout( isScrolling );

				//$scrollDiv.addClass('scrolling');
				//$('.img-tooltip .tip').removeAttr('style');
				tooltips.hide();

				// Set a timeout to run after scrolling ends
				isScrolling = setTimeout(function() {

					//$scrollDiv.removeClass('scrolling');
					tooltips.css('display','');
				}, 66);

			});
		});			
	}
	clearTooltipOnScroll();

	//$(document).on('hover','.open .img-tooltip',function(){
	$(document).on('mousemove', '.open .img-tooltip', function (e) {
		//$('.img-tooltip').each(function () {

		var $tip = $(this).find('.tip');

		// $this.hover(function() {

		//     $($tip).show();

		// }, function() {

		//     $($tip).hide().removeAttr('style');

		//$(this).mouseover(function (e) {
		var mouseX = e.pageX;
		var mouseY = e.pageY;

		$($tip).css({

			top: mouseY, left: mouseX

		});
		//});
		//});
	});
	var slowload;
	$( document ).ajaxStart(function() {
		slowload = setTimeout(function(){
			$('.main .section.open').addClass('slowloading');
		},5000);
	});
	$( document ).ajaxComplete(function() {
		clearTimeout(slowload);
		$('.slowloading').removeClass('slowloading');

		// Analytics //
		ga('set', 'page', location.pathname);
		ga('send', 'pageview');

		setTimeout(function(){
			lazyImgs();
			iframesReady();
			clearTooltipOnScroll();
			//featuredProjectsPadding();
			//videoAjaxFix();
			//videoAjaxFix();
			//videoReady();
			//videoControls();
			//marqueeListTitle();
		},transitionTime);
		fourofour();
	});
	//document.body.classList.add('loading-font');

	/*eshint undef:false */
	// var FavoritReg = new FontFaceObserver('Favorit-Regular');
	// /*eshint undef:false */
	// var FavoritRegItal = new FontFaceObserver('Favorit_Regular-Italic');

	// Promise.all([FavoritReg.load(null, 60000), FavoritRegItal.load(null, 60000)]).then(function () {
	// 	document.body.classList.add('font-loaded');
	// });



	var mobileLayout = false;
	
	if($('#news').width() === $(window).width()){
		mobileLayout = true;
	}
	$(window).resize(function(){
		if($('#news').width() === $(window).width()){
			mobileLayout = true;
		}else{
			mobileLayout = false;
		}
	});
		
	function closeIntro(){
		// document.body.classList.remove('home');
		// document.body.classList.add('intro-closed projects');
		$('body').removeClass('home').addClass('intro-closed');
		setTimeout(function(){

			$('body').removeClass('intro-closed').addClass('projects');
			//$('#projects').addClass('open');
			idle();
			$('#intro').fadeOut(300,function(){
				$(this).remove();	
			});
			
			// var href = 	sitevars.homeurl+'/projects/';	
			// window.history.pushState({path:href},'',href);
			// document.title = 'Projects  |  Sibling';	

		},1100);		
	}




// canAutoplay.video({timeout: 100, muted: true}).then(({result}) => {
//   if (result === true) {
//     window.console.log('yes');
//   } else {
//    window.console.log('no');
//   }
// })
	function vidObjectFitPoly(video,wrap){
		// Detect objectFit support
		if('objectFit' in document.documentElement.style === false) {
		  
			var vr = video.videoWidth/video.videoHeight;
			var ww = wrap.clientWidth;
			var wh = wrap.clientHeight;
			var wr = ww/wh;
			if(vr > wr){
				var rh = wh*vr;
				var l = -(rh - ww)*0.5;
				video.style.height = Math.floor(wh) + "px";
				video.style.width = Math.floor(rh) + "px";
				video.style.left = l + "px";
				video.style.top = "0px";
			}else{
				var rw = ww/vr;
				var t = -(rw - wh)*0.5;
				video.style.width = Math.floor(ww) + "px";
				video.style.height = Math.floor(rw) + "px";
				window.console.log(ww,rw);
				video.style.top = t + "px";
				video.style.left = "0px";		
			}

		}

	}	

	function fadeOutLoading(){
		$('#intro').css('visibility','visible');
		$('#loading').css({
			'background':'none',
			'pointer-events':'none'
		});
		$('.loader').fadeOut();
		setTimeout(function(){
			$('#loading').addClass('stop-anim');
			setTimeout(function(){
				$('#loading').fadeOut();
			},4000);	
		},6000);
	}

	function introVideo(){

		var introVideo = document.getElementById('intro-video');

		Cookies.set('sibling_projects_display', 'featured');
		Cookies.remove('sibling_projects_view');
		Cookies.remove('sibling_projects_order');
		Cookies.remove('sibling_news_url');

		
		var d = new Date(); 
		var t = d.getTime();

	    var checkVideo = setInterval(function(){
			
	    	if(introVideo.readyState === 4){

	    		vidObjectFitPoly(introVideo,document.getElementById('introwrap'));
	    		clearInterval(checkVideo);
				
				var d = new Date();
					t = d.getTime() - t;
					t = 4000 - t;
					t = t > 0 ? t : 100;

				//$(".loadbar").animate({width:'100%'}, t - 50);
	   //  		$(".loadbar")
	   //  			.css('transition','transform '+ (t - 50) +'ms linear')
	   //  			.css('transform','scale(1,1)');

				// //$(".loadbar").width("100%");

	   //  		setTimeout(function(){
				// 	introVideo.play();
				// 	fadeOutLoading();	
				// },t);

				var transitionEvent = whichTransitionEvent();

				$(".loadbar")
					.css('transition','transform '+ t +'ms linear')
					.css('transform','scale(1,1)').one(transitionEvent,
				        function() {
				        	fadeOutLoading();

				});

	    	}else{
	    		$(".loadbar")
	    			.css('transition','transform 500ms linear')
	    			.css('transform','scale('+introVideo.readyState*(1/4)+',1)');
	    	}  
	    },500); 
	}

	// function loadFallbackImg(imgUrl){
	//     Image.prototype.onChangeSize;
	//     Image.prototype.load = function(url){
	//         var _this = this,
	//             req   = ((XMLHttpRequest) ? new XMLHttpRequest() : new ActiveXObject("Microsoft.XMLHTTP"));

	//         req.open('GET', url, true);
	//         req.setRequestHeader('content-encoding','none'); 
	//         req.responseType = 'arraybuffer';

	//         req.onload = function() {
	//           if(req.response) {
	//             var blob = new Blob([req.response]);
	//             _this.src = window.URL.createObjectURL(blob);
	//           }
	//         }
	//         req.upload.onprogress = function(e) {	
	// 			var contentLength;
	// 			if (e.lengthComputable) {
	// 			contentLength = e.total;
	// 			} else {
	// 			contentLength = parseInt(e.target.getResponseHeader("Content-Encoding: none"), 10);
	// 			}	                	
	//         	window.console.log(contentLength);
	//           if(_this.onChangeSize) {
	//             _this.onChangeSize(e.loaded, e.total);
	//           }
	//         }
	//         req.send();
	//     }
	//     var img = new Image();
	//     img.onChangeSize = function(loaded, total) {
	//         var loadingPercentage = parseInt((loaded / total) * 100);
	//         //$('#loadingPercentage').html(loaded + " - " + total + " byte - " + loadingPercentage + "%");
	//         //window.console.log(loaded + " - " + total + " byte - " + loadingPercentage);
	//     }
	//     img.onload = function() {
	//       //load completed actions here.
	//       $('#introwrap').append('<div class="intro-fallback" style="background-image:url('+img.src+')"></div>');
	//     }
	//     img.load(imgUrl);
	// }
	// Function from David Walsh: http://davidwalsh.name/css-animation-callback
	function whichTransitionEvent(){
	  var t,
	      el = document.createElement("fakeelement");

	  var transitions = {
	    "transition"      : "transitionend",
	    "OTransition"     : "oTransitionEnd",
	    "MozTransition"   : "transitionend",
	    "WebkitTransition": "webkitTransitionEnd"
	  }

	  for (t in transitions){
	    if (el.style[t] !== undefined){
	      return transitions[t];
	    }
	  }
	}

	function introFallback(){
		let d = new Date(); 
		let t = d.getTime();

		$(".loadbar")
			.css('transition','transform 500ms linear')
			.css('transform','scale(0.75,1)');

		let introVideo = document.getElementById('intro-video');
		introVideo.parentNode.removeChild(introVideo);
		let introFallbackSrc = document.getElementById('introwrap').getAttribute('data-fallbackimg');
		let fallbackImg = new Image();
		fallbackImg.src = introFallbackSrc; 
		fallbackImg.onload = function () {
			$('#introwrap').append('<div class="intro-fallback" style="background-image:url('+introFallbackSrc+')"></div>');
			let d = new Date();
				t = d.getTime() - t;
				t = 8000 - t;
				t = t > 0 ? t : 0;
	
			// $(".loadbar")
			// 	.css('transition','transform '+ t +'ms linear')
			// 	.css('transform','scale(1,1)');	

			// setTimeout(function(){
			// 	fadeOutLoading();	
			// },t + 1000);
			var transitionEvent = whichTransitionEvent();

			$(".loadbar")
				.css('transition','transform '+ t +'ms linear')
				.css('transform','scale(1,1)').one(transitionEvent,
			        function() {
			        	fadeOutLoading();

			});
									
		};		
	}			

	var intro = document.getElementById('intro');
	if(intro){

	    var video = document.createElement('video');
	    video.autoplay = true;
	    video.muted = true;
	    video.setAttribute('webkit-playsinline', 'webkit-playsinline');
	    video.setAttribute('playsinline', 'playsinline');    
	    video.src = 'data:video/mp4;base64,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';
	    video.type = "video/mp4";
	    // video.playing = false;
	    // video.play();
	    video.oncanplay = function() {
			var promise = video.play();
			if (promise !== undefined) {
				promise.then(function(){
					introVideo();
				}).catch(function(){
					introFallback();
				});
			}else{
				introVideo();
			}
		}

			

		intro.addEventListener('click', function() {
			closeIntro();
			var href = 	sitevars.homeurl+'/projects/';	
			window.history.pushState({path:href},'',href);
			document.title = 'Projects  |  Sibling';			
			$('#projects').addClass('open');
		});

		// var lastScrollTop = 0;
		// $(window).scroll(function(){
		//    var st = $(this).scrollTop();
		//    if (st > lastScrollTop){
		//        // downscroll code
		//        window.console.log('down');
		//    } else {
		//       // upscroll code
		//       window.console.log('up');
		//    }
		//    lastScrollTop = st;
		// });
		$('#intro-video').bind('mousewheel', function(e){
			if(e.originalEvent.deltaY > 0){
				closeIntro();
				var href = 	sitevars.homeurl+'/projects/';	
				window.history.pushState({path:href},'',href);
				document.title = 'Projects  |  Sibling';					
				$('#projects').addClass('open');
			}
		});		
	}



	function idle(){
		if(!document.body.classList.contains('home')){
			var i = setTimeout(function(){
				
					//if(!document.body.classList.contains('home')){
					
						document.body.classList.add('idle');
						var t = setTimeout(function(){
							document.body.classList.add('idle-timeout');
						},5000);		
						//$(document).click(function() {
						$(document).on('click, mousemove touchstart',function() {	
							clearTimeout(t);
							$('body').removeClass('idle idle-timeout');
							idle();
						});
					// }else{
					// 	clearTimeout(i);
					// 	idle();				
					// }
			
				
			},20000);

			$(document).on('mousemove touchstart scroll',function() {	
				clearTimeout(i);
				//idle();
			});

		}


	}
	idle();	


	function featuredProjectsPadding(){
		var $featProjects = $('#projects.open #featured-projects');
		if($featProjects.length){
			var winH = $(window).height();
			var contentH = $('.top-bar').outerHeight() + $('.featured-project').first().outerHeight(true);
						   // $('.featured-project').first().find('.feat-img').outerHeight(true) + 
						   // $('.featured-project').first().find('.project-details').outerHeight();
			   
			var p = winH - contentH;	
			//if(p > 70){
			if(p > 200){	
				$featProjects.css({'padding-top':p,'opacity':1});
			}else{
				$featProjects.css('opacity',1).removeAttr('style');
			}
		}else{
			$('#featured-projects').removeAttr('style');
		}
	}
	featuredProjectsPadding();

	$(window).resize(function(){
		featuredProjectsPadding();
	});	

	// if($('#news').width() === $(window).width()){
	// 	mobileLayout = true;
	// }

	// var resizeTimer;
	// var layout = mobileLayout;

	// $(window).on('resize', function() {
	// 	//clearTimeout(resizeTimer);
	// 	//window.console.log(layout,mobileLayout);
	// 	resizeTimer = setTimeout(function() {
	// 		// featuredProjectsPadding(); 
						
	// 		// if(layout !== mobileLayout){
	// 		// 	window.console.log('b');				
	// 		// }
	// 		// layout = mobileLayout;
	// 	}, 250);

	// });

	var resizeTimer;
	$(window).resize(function(){
		document.body.classList.add('resizing');
		clearTimeout(resizeTimer);
		resizeTimer = setTimeout(function() {
			document.body.classList.remove('resizing');
		}, 250);
	});

	

	var currentSection = function(){
		var holder = document.getElementById('studio-expanded');
		var el = document.getElementsByClassName("studio-section");
		var inview = [];

		var i;
		for (i = 0; i < el.length; i++) {
		    var elemTop = el[i].getBoundingClientRect().top;
		    var elemBottom = el[i].getBoundingClientRect().bottom;
		    //var elemHeight = el[i].getBoundingClientRect().height;
		    var holderTop = holder.getBoundingClientRect().top;
		    //var holderBottom = holder.getBoundingClientRect().bottom;

		    //if (elemTop >= holderTop && elemBottom - holderBottom < elemHeight) {
		    if (elemTop <= holderTop && elemBottom > holderTop) {

				inview.push(el[i].id);
		
			}
			//window.console.log(el[i],elemTop,holderTop,elemBottom,holderTop);

		}
		if(inview.length > 0){
			$('.scrollto.active').removeClass('active');
			$('.scrollto[href$="#'+inview[0]+'"]').addClass('active');
		}
		// else{
		// 	$('.studio-nav .scrollto').first().addClass('active');
		// }			
	};
	if($('#studio-expanded').length){
		//currentSection();
		$('#studio-expanded').bind('scroll',currentSection);
	}	

	$(document).on('click','.open-section',function(){
		if(!$('body').hasClass('doingajax') && !$(this).closest('.section').hasClass('open')){

			$('body').addClass('doingajax');

			// for mobile //
			//$('body').removeClass('home').addClass('intro-closed');
			if(mobileLayout){
				closeIntro();
			}
			
			var $this = $(this);
			var href = $this.attr('href');
			var open = '#' + $('section.open').attr('id');
			var section = '#' + $(this).closest('section.section').attr('id');
			var d = new Date();
			var t = d.getTime();

			if($(this).attr('id') === 'all-news' && $('#news').hasClass('closed') && Cookies.get('sibling_news_url')){
				href = Cookies.get('sibling_news_url');
			}

			// var newsurl = $('#all-news').attr('href');

			// if(newsurl.indexOf("/page/") != -1){
			// 	newsurl = newsurl.replace(/\/$/, ''); 
			// 	var lastSeg = newsurl.substr(newsurl.lastIndexOf('/') + 1);
			// 	hrefWithNewsPage = href + '?excerpts-paged=' + lastSeg; 
			// }
			// var hrefPaged = href;
			// var newsPage = Cookies.get("sibling_news_page");
			// if(newsPage !== undefined && newsPage > 1){
			// 	hrefPaged = href + '?excerpts-paged=' + newsPage; 				
			// }	

			$(open).removeClass('open').addClass('closing');
			//$('#news,#studio').addClass('closing');			

			$(section).addClass('open opening');

			if($('body').hasClass('single-projects')){
				$('body').addClass('closing-project').removeClass('single-projects');
			}

			$.ajax({
			    url: href,
			    datatype: "html",
			    success: function(data){

					var parser = new DOMParser();
					var doc = parser.parseFromString(data, "text/html");
					var docClass = doc.body.getAttribute('class');			
					var d = new Date();
						t = d.getTime() - t;
						t = transitionTime - t;
						t = t > 0 ? t : 0;

					// if($('body').hasClass('font-loaded')){
					// 	docClass += ' font-loaded';
					// }

					setTimeout(function(){

						if(open !== '#projects'){
							var compressedContent = $(doc).find(open + ' .section-wrap > *');
							$(open + ' .section-wrap').html(compressedContent);
						}

						// if(open === '#studio' && $('#shop-wrap').length){
						// 	window.console.log('closing shop');
						// }

						//console.log(section, href, $(doc).find(section + ' .content'));

						if(section !== '#projects'){
							var expandedContent = $(doc).find(section + ' .content');
							$(section + ' .ajaxwrap').html(expandedContent);
						}

						$('.section').not(section).each(function(){
							if($(this).find('.content').length < 1){
								var sectionId = '#' + $(this).attr('id');
								//window.console.log(sectionId);
								var content = $(doc).find(sectionId + ' .content');
								$(sectionId + ' .ajaxwrap').html(content);								
							}
						});

						if($('#project-wrap').length){
							var index = document.getElementById('index');
							if(index){
								$('#project-wrap').fadeOut(function(){
									$(this).remove();
									$('#index').show();
								});
							}else{
								var projectContent = $(doc).find('#index');

								$('#projects').html(projectContent);
								////safariAjaxImgs(projectContent);
								
							}
							$('body').removeClass('closing-project');							
						}

						featuredProjectsPadding();



						//$('body').removeClass('doingajax');
						document.body.className = docClass;
						$(open).removeClass('closing').addClass('closed');
						$(section).removeClass('opening closed');

						if(section === '#news' && href.indexOf("#") != -1){
							var newsHash = href.split('#')[1];
							var $newsContent = $('#news .content');
							if(newsHash){
								//window.console.log(newsHash);
								setTimeout(function(){
									$newsContent.scrollTop($newsContent.scrollTop() - $newsContent.offset().top + $('#'+newsHash).offset().top);
								},0);
							}
						}

						if(section === '#studio'){
							var hash = href.split('#')[1];
							if(hash){
								$('.studio-nav .scrollto.active').removeClass('active');
								setTimeout(function(){
									$('.studio-nav .scrollto[href$="#'+hash+'"]').trigger('click');
								},250);
							}else{
								$('#studio-expanded').bind('scroll',currentSection);
							}	
						}

					},t);

					var title = $(data).filter('title').text();
			    	window.history.pushState('.open-section','',href);
					document.title = title;					
				},
				error: function(){
					window.location = href;
				}						   
			});

			
		}
		return false;	
	});	

	
	if(mobileLayout){
		if($('body').hasClass('home')){
			$('#projects').removeClass('open');
		}
		//$('.top-bar').one('click',function(){
		// $('.top-bar').on('click',function(){	
		// 	$(this).find('.open-section').trigger('click');
		// 	return false;
		// });	

		// $('.top-bar').on('click',function(e){
		// 	if(!$(this).closest('section.section').hasClass('open')){
		// 		window.console.log('click');
		// 		$(this).find('.open-section').triggerHandler('click');
		// 		e.stopPropagation();
		// 	}
		// });

		var href = sitevars.homeurl + '/all-projects/';
		$.ajax({
			url: href,
			datatype: "html",
			success: function(data){

				var parser = new DOMParser();
				var doc = parser.parseFromString(data, "text/html");
				var projectContent = $(doc).find('#projects .ajaxwrap');
				var projectClass = $(doc).find('#projects').attr('class');

				$('#projects .ajaxwrap').html(projectContent);
				$('#projects').attr('class',projectClass);
				$('#projects').removeClass('open');
				$('.project-view.grid-view').addClass('active');

			}			
						   
		});
	}			
	

	$(document).on('click','.projects-displayed',function(){
		if(!$('body').hasClass('doingajax')){

			$('body').addClass('doingajax');

			var href = $(this).attr('href');
			var open = false;
			var $projects = $('#projects');
			var d = new Date();
			var t = d.getTime();

			var view = 'grid';
			if (href.indexOf('/projects/') !== -1) {
				view = 'featured';
			} else if (href.indexOf('view=list') !== -1) {
				view = 'list';
			}
			Cookies.set('sibling_projects_display', view);

			// for mobile //
			//$('body').removeClass('home').addClass('intro-closed');
			$('body').removeClass('home');

			$('.projects-displayed.active').removeClass('active');
			$('.projects-displayed[href="'+href+'"]').addClass('active');

			// if(href.indexOf('/all-projects/') !== -1){
			// 	$projects.addClass('all');
			// 	$projects.removeClass('featured');
			// } else {
			// 	$projects.removeClass('all');
			// 	$projects.addClass('featured');
			// }

			if(!$projects.hasClass('open')){
				open = '#' + $('section.open').attr('id');
				$(open).removeClass('open').addClass('closing');
				$projects.addClass('open');
			}
			$projects.addClass('opening');
			
			if($(open).find('.img-tooltip').length){
				$( ".img-tooltip" ).removeClass('active');
			}

			// var hrefPaged = href;
			// var newsPage = Cookies.get("sibling_news_page");
			// if(newsPage !== undefined && newsPage > 1){
			// 	hrefPaged = href + '?excerpts-paged=' + newsPage; 				
			// }
			if(view === 'grid'){
				$('.project-view.list-view').removeClass('active');
				$('.project-view.grid-view').addClass('active');
			}
			if(view === 'list'){
				$('.project-view.list-view').addClass('active');
				$('.project-view.grid-view').removeClass('active');
			}

			$.ajax({
			    url: href,
			    datatype: "html",
			    success: function(data){

					var parser = new DOMParser();
					var doc = parser.parseFromString(data, "text/html");			
					var d = new Date();
						t = d.getTime() - t;
						t = transitionTime - t;
						t = t > 0 ? t : 0;

					var projectContent = $(doc).find('#projects .content');
					var projectClass = $(doc).find('#projects').attr('class');

					setTimeout(function(){

						if(open){
							var compressedContent = $(doc).find(open + ' .content');
							$(open + ' .ajaxwrap').html(compressedContent);
						}
											
						$projects.find('.ajaxwrap').html(projectContent);
						$projects.attr('class',projectClass);

						$('body').removeClass('doingajax');
						if(open){
							$(open).removeClass('closing');
						}
						$projects.removeClass('opening closed');
						updatingProjectFilterAndOrder()
						featuredProjectsPadding();

						if($projects.find('.img-tooltip').length){
							$( ".img-tooltip" ).addClass('active');
						}

						if(view === 'featured'){
							Cookies.remove('sibling_projects_filters');
							Cookies.remove('sibling_projects_order');
							$('.all-projects-link').attr('href', sitevars.homeurl + '/all-projects/');
							$('.project-view.list-view').removeClass('active');
							$('.project-view.grid-view').addClass('active');
						}
					},t);

					$('#projects .open-section').attr('href',href);

					var title = $(data).filter('title').text();
					window.history.pushState('.projects-displayed','',href);
					document.title = title;	
					
				},
				error: function(){
					window.location = href;
				}						   
			});

			
		}
		return false;	
	});


	$(document).on('click','#projects.section.open .open-section',function(e){
		e.preventDefault();
		//if(!$('body').hasClass('doingajax') && $('#all-projects').length === 0){
		if(!$('body').hasClass('doingajax')){
			$('body').addClass('doingajax');

			Cookies.remove('sibling_projects_filters');
			Cookies.remove('sibling_projects_order');

			var href = sitevars.homeurl + '/all-projects/';
			//var open = false;
			var $projects = $('#projects');
			var d = new Date();
			var t = d.getTime();

			// var view = 'grid';
			// if (href.indexOf('/projects/') !== -1) {
			// 	view = 'featured';
			// } else if (href.indexOf('view=list') !== -1) {
			// 	view = 'list';
			// }
			// Cookies.set('sibling_projects_display', view);
			Cookies.set('sibling_projects_display', 'grid');

			// for mobile //
			//$('body').removeClass('home').addClass('intro-closed');
			$('body').removeClass('home');

			$('.projects-displayed.active').removeClass('active');
			$('.projects-displayed[href="'+href+'"]').addClass('active');


			//if(view === 'grid'){
				$('.project-view.list-view').removeClass('active');
				$('.project-view.grid-view').addClass('active');
			// }
			// if(view === 'list'){
			// 	$('.project-view.list-view').addClass('active');
			// 	$('.project-view.grid-view').removeClass('active');
			// }

			$.ajax({
			    url: href,
			    datatype: "html",
			    success: function(data){

					var parser = new DOMParser();
					var doc = parser.parseFromString(data, "text/html");			
					var d = new Date();
						t = d.getTime() - t;
						t = transitionTime - t;
						t = t > 0 ? t : 0;

					var projectContent = $(doc).find('#projects .content');
					var projectClass = $(doc).find('#projects').attr('class');

					setTimeout(function(){

						// if(open){
						// 	var compressedContent = $(doc).find(open + ' .content');
						// 	$(open + ' .ajaxwrap').html(compressedContent);
						// }
											
						$projects.find('.ajaxwrap').html(projectContent);
						$projects.attr('class',projectClass);

						$('body').removeClass('doingajax');
						// if(open){
						// 	$(open).removeClass('closing');
						// }
						$projects.removeClass('opening closed');
						updatingProjectFilterAndOrder()
						featuredProjectsPadding();

						// if($projects.find('.img-tooltip').length){
						// 	$( ".img-tooltip" ).addClass('active');
						// }

						// if(view === 'featured'){
						// 	Cookies.remove('sibling_projects_filters');
						// 	Cookies.remove('sibling_projects_order');
						// 	$('.all-projects-link').attr('href', sitevars.homeurl + '/all-projects/');
						// 	$('.project-view.list-view').removeClass('active');
						// 	$('.project-view.grid-view').addClass('active');
						// }
					},t);

					$('#projects .open-section').attr('href',href);

					var title = $(data).filter('title').text();
					window.history.pushState('.projects-displayed','',href);
					document.title = title;	
					
				},
				error: function(){
					window.location = href;
				}						   
			});

			
		}
		return false;	
	});

	let updatingProjectsView = false;

	function updatingProjectFilterAndOrder(){
		if($('#all-projects .sorting').length !== 0){
			var $activeFilters = $('.filters button.active');
			if($('#all-projects-list').length !== 0){
				$activeFilters.each(function(){
					var filter = $(this).data('category');
					$('.projects-list>.project[data-category*="'+filter+'"]').addClass('highlight');
				});
			}else{
				var $cards = $('.projects-grid>.project-card');
				if ($activeFilters.length === 0) {
					$cards.show();
				} else {
					$cards.hide();
					$activeFilters.each(function(){
						var filter = $(this).data('category');
						$cards.filter('[data-category*="'+filter+'"]').show();
					});
				}
			}

			var activeOrder = $('.order button.active');

			if(activeOrder.length > 0){
				var $projectlist = $('.projects-index');
				var $projectItem = $('.projects-index > .project-item');
				var order = getProjectOrderById(activeOrder.attr('id'), $projectItem);

				$projectlist.html(order);
			}
		}	
	}	

	updatingProjectFilterAndOrder();

	$(document).on('click','.project-view',function(e){
		e.preventDefault();
		e.stopPropagation();
		if(updatingProjectsView || $(this).hasClass('active')) return false;
		
			updatingProjectsView = true;
			

			var href = $(this).attr('href');
			var open = false;
			var $projects = $('#projects');
			var d = new Date();
			var t = d.getTime();
			var updatingView = $('.projects-index').length !== 0;

			if($projects.hasClass('open')){
				$('body').addClass('updating-project-view');
			}else{
				$('body').addClass('doingajax');
			}

			if(!$projects.hasClass('open')){
				open = '#' + $('section.open').attr('id');
				$(open).removeClass('open').addClass('closing');
				$projects.addClass('open');
			}
			//$projects.addClass('opening');

			var view = 'grid';
			if (href.indexOf('/projects/') !== -1) {
				view = 'featured';
			} else if (href.indexOf('view=list') !== -1) {
				view = 'list';
			}
			Cookies.set('sibling_projects_display', view);

			// for mobile //
			//$('body').removeClass('home').addClass('intro-closed');
			$('body').removeClass('home');

			$('.project-view.active').removeClass('active');
			$('.project-view[href="'+href+'"]').addClass('active');

			// if(href.indexOf('/all-projects/') !== -1){
			// 	$projects.addClass('all');
			// 	$projects.removeClass('featured');
			// } else {
			// 	$projects.removeClass('all');
			// 	$projects.addClass('featured');
			// }

			
			if($(open).find('.img-tooltip').length){
				$( ".img-tooltip" ).removeClass('active');
			}

			// var hrefPaged = href;
			// var newsPage = Cookies.get("sibling_news_page");
			// if(newsPage !== undefined && newsPage > 1){
			// 	hrefPaged = href + '?excerpts-paged=' + newsPage; 				
			// }

			$.ajax({
			    url: href,
			    datatype: "html",
			    success: function(data){

					var parser = new DOMParser();
					var doc = parser.parseFromString(data, "text/html");			
					var d = new Date();
						t = d.getTime() - t;
						t = transitionTime - t;
						t = t > 0 ? t : 0;

					//var projectContent = updatingView ? $(doc).find('#projects .projects-index') : $(doc).find('#projects .content');

					// if(updatingView){
					// 	$('#projects .projects-index-wrap').html($(doc).find('#projects .projects-index'));
					// 	$('.filters button.active').each(function(){
					// 		var filter = $(this).data('category');
					// 		if($('#all-projects-list').length !== 0){
					// 			$('.projects-list>.project[data-category*="'+filter+'"]').addClass('highlight');
					// 		}else{	
					// 			$('.projects-grid>.project-card').hide();
					// 			$('.projects-grid>.project-card[data-category*="'+filter+'"]').show();
					// 		}
					// 	});
					// }else{
					// 	$('#projects .ajaxwrap').html($(doc).find('#projects .content'));
					// }

					var projectClass = $(doc).find('#projects').attr('class');



					setTimeout(function(){

						if(open){
							var compressedContent = $(doc).find(open + ' .content');
							$(open + ' .ajaxwrap').html(compressedContent);
						}
							
						//updatingView ? $('#projects .projects-index-wrap').html(projectContent) : $('#projects .ajaxwrap').html(projectContent);
						if(updatingView){
							$('#projects .projects-index-wrap').html($(doc).find('#projects .projects-index'));
						}else{
							$('#projects .ajaxwrap').html($(doc).find('#projects .content'));
						}
						updatingProjectFilterAndOrder()
						$projects.attr('class',projectClass);

						$('body').removeClass('doingajax');
						$('body').removeClass('updating-project-view');

						if(open){
							$(open).removeClass('closing');
						}
						$projects.removeClass('opening closed');

						featuredProjectsPadding();

						if($projects.find('.img-tooltip').length){
							$( ".img-tooltip" ).addClass('active');
						}
						updatingProjectsView = false;

					},t);

					$('#projects .open-section').attr('href',href);

					var title = $(data).filter('title').text();
					window.history.pushState('.project-view','',href);
					document.title = title;					
				},
				error: function(){
					window.location = href;
				}						   
			});
	});




	// $(document).on('click','#all-news',function(){
	// 	if(!$('body').hasClass('doingajax')){

	// 		var href = $(this).attr('href');
	// 		var open = false;
	// 		var $news = $('#news');
	// 		var d = new Date();
	// 		var t = d.getTime();

	// 		$('body').addClass('doingajax');

	// 		// for mobile //
	// 		//$('body').removeClass('home').addClass('intro-closed');
	// 		$('body').removeClass('home');

	// 		if(!$news.hasClass('open')){
	// 			open = '#' + $('section.open').attr('id');
	// 			$(open).removeClass('open').addClass('closing');
	// 			$news.addClass('open');
	// 		}
	// 		$news.addClass('opening');

	// 		$.ajax({
	// 		    url: href,
	// 		    datatype: "html",
	// 		    success: function(data){

	// 				var parser = new DOMParser();
	// 				var doc = parser.parseFromString(data, "text/html");			
	// 				var d = new Date();
	// 					t = d.getTime() - t;
	// 					t = transitionTime - t;
	// 					t = t > 0 ? t : 0;

	// 				var newsContent = $(doc).find('#news .content');

	// 				setTimeout(function(){

	// 					if(open){
	// 						var compressedContent = $(doc).find(open + ' .content');
	// 						$(open + ' .ajaxwrap').html(compressedContent);
	// 					}
											
	// 					$news.find('.ajaxwrap').html(newsContent);
	// 					$('body').removeClass('doingajax');
	// 					if(open){
	// 						$(open).removeClass('closing');
	// 					}
	// 					$news.removeClass('opening closed');
											
	// 				},t);

	// 				var title = $(data).filter('title').text();
	// 				window.history.pushState('#all-news','',href);
	// 				document.title = title;					
	// 			},
	// 			error: function(){
	// 				window.location = href;
	// 			}						   
	// 		});
			
	// 	}
	// 	return false;	
	// });	


	$(document).on('click','.project-link',function(){

		if(!$('body').hasClass('doingajax')){
			if(!$(this).hasClass('related-project-link')){
				Cookies.set('sibling_last_page',window.location.href);
				Cookies.set('sibling_projects_scroll',$('#projects .content').scrollTop());
				Cookies.set('sibling_news_scroll',$('#news .content').scrollTop());
				Cookies.set('sibling_studio_scroll',$('#studio .content').scrollTop());
			}	

			$('body').addClass('doingajax opening-project single-projects');
			
			var href = $(this).attr('href');
			var d = new Date();
			var t = d.getTime();
			//var open = '#' + $('section.open').attr('id');

			$('#news,#studio').removeClass('open');
			$('#projects').addClass('open closing');			

			$.ajax({
			    url: href,
			    datatype: "html",
			    success: function(data){

					var parser = new DOMParser();
					var doc = parser.parseFromString(data, "text/html");
					var projectContent = $(doc).find('#project-wrap');
			
					var d = new Date();
						t = d.getTime() - t;
						t = transitionTime - t;
						t = t > 0 ? t : 0;
					// $('#index').hide();
					// if($('#project-wrap').length){
					// 	$('#project-wrap').remove();	
					// }
					$('#projects').html(projectContent);
					//safariAjaxImgs(projectContent);

					setTimeout(function(){
						$('body').removeClass('doingajax opening-project');
						$('#projects').removeClass('closing closed');

						marqueeLongTitle();

					},t + 1000);

					var title = $(data).filter('title').text();
					window.history.pushState('.project-link','',href);
					document.title = title;	

				},
				error: function(){
					window.location = href;
				}						   
			});			
		}
		return false;	
	});	

	// var projectsUrl = sessionStorage.getItem("projectsUrl");
	// //var newsPage = sessionStorage.getItem("newsPage");
	// var $backToIndex = $('#project-wrap .back-to-index');
	// if($backToIndex.length && projectsUrl !== null){
	// 	$backToIndex.attr('href',projectsUrl);
	// }

	// if (projectsUrl !== null && projectsUrl.indexOf('all-projects') !== -1 && document.getElementById('all-projects') === null){
	// 	var $projectsWrap = $('#projects .ajaxwrap');
	// 	$projectsWrap.hide();

	// 	$('.project-nav').hide();
	// 	setTimeout(function(){ $('.project-nav').show(); },600);
	// 	$('.project-view.active').removeClass('active');
	// 	$('.project-view[href^="'+projectsUrl+'"]').addClass('active');
	// 	$('#projects .open-section').attr('href',projectsUrl);

	// 	$.ajax({
	// 	    url: projectsUrl,
	// 	    datatype: "html",
	// 	    success: function(data){

	// 			var parser = new DOMParser();
	// 			var doc = parser.parseFromString(data, "text/html");
	// 			var projectContent = $(doc).find('#projects .content');
			
	// 			$projectsWrap.html(projectContent);
	// 			//featuredProjectsPadding();
	// 			$( ".img-tooltip" ).addClass('active');
	// 			$projectsWrap.removeAttr('style');
	// 		}						   
	// 	});

	// }

	// if (window.location.href.indexOf('/news/page/') === -1 && newsPage !== null && newsPage > 1 && document.getElementById('news') !== null){
	// 	var $newsWrap = $('#news .ajaxwrap');
	// 	$newsWrap.hide();

	// 	$('#all-news').attr('href',sitevars.homeurl + '/news/page/' + newsPage);

	// 	var newsPgHref = sitevars.homeurl + '?excerpts-paged=' + newsPage;
	// 	if($('#news-expanded').length){
	// 		newsPgHref = sitevars.homeurl + '/news/page/' + newsPage;
	// 	}

	// 	$.ajax({
	// 	    url: newsPgHref,
	// 	    datatype: "html",
	// 	    success: function(data){

	// 			var parser = new DOMParser();
	// 			var doc = parser.parseFromString(data, "text/html");
	// 			var projectContent = $(doc).find('#news .content');
			
	// 			$newsWrap
	// 				.html(projectContent)
	// 				.removeAttr('style');
	// 		}						   
	// 	});

	// }

	$(document).on('click','.back-to-index',function(){
		if(!$('body').hasClass('doingajax')){

			$('body').addClass('doingajax closing-project');
			
			var href = $(this).attr('href');
			var d = new Date();
			var t = d.getTime();

			// var hrefPaged = href;
			// var newsPage = Cookies.get("sibling_news_page");
			// if(newsPage !== undefined && newsPage > 1){
			// 	hrefPaged = href + '?excerpts-paged=' + newsPage; 				
			// }

			setTimeout(function(){
				$('#project-wrap').remove();
				$('body').removeClass('single-projects');
			},500);	
	
			// var index = document.getElementById('index');
			// if(index){
				
				// setTimeout(function(){
				// 	index.style.display='block';
				// },1000);

				// var newsExpanded = document.getElementById('news-expanded');
				// var studioExpanded = document.getElementById('studio-expanded');
				
				// if(newsExpanded || studioExpanded){
					// var newsurl = $('#all-news').attr('href');
					// var hrefPaged = href;
					// if(newsurl.indexOf("/page/") != -1){
					// 	newsurl = newsurl.replace(/\/$/, ''); 
					// 	var lastSeg = newsurl.substr(newsurl.lastIndexOf('/') + 1);
					// 	hrefPaged = href + '?excerpts-paged=' + lastSeg; 
					// }										
					$.ajax({
					    url: href,
					    datatype: "html",
					    success: function(data){

							var parser = new DOMParser();
							var doc = parser.parseFromString(data, "text/html");
							var newsContent = $(doc).find('#news .section-wrap');
							var newsClass = $(doc).find('#news').attr('class');
							var studioContent = $(doc).find('#studio .section-wrap');
							var studioClass = $(doc).find('#studio').attr('class');
							var projectContent = $(doc).find('#projects .section-wrap');
							var projectClass = $(doc).find('#projects').attr('class');

							var projectsScroll = Cookies.get('sibling_projects_scroll');
							var newsScroll = Cookies.get('sibling_news_scroll');
							var studioScroll = Cookies.get('sibling_studio_scroll');
					
							var d = new Date();
								t = d.getTime() - t;
								t = transitionTime - t;
								t = t > 0 ? t : 0;

							$('#news').html(newsContent);
							$('#news').attr('class',newsClass);
							$('#studio').html(studioContent);
							$('#studio').attr('class',studioClass);
							$('#projects').html(projectContent);
							$('#projects').attr('class',projectClass);

							updatingProjectFilterAndOrder()
							
							setTimeout(function(){
								if(projectsScroll){
									$('#projects .content').scrollTop(projectsScroll);
								}
								if(newsScroll){
									$('#news .content').scrollTop(newsScroll);
								}
								if(studioScroll){
									$('#studio .content').scrollTop(studioScroll);
								}
								featuredProjectsPadding();
								$('body').removeClass('doingajax closing-project');

							},t + 500);

							var title = $(data).filter('title').text();
							window.history.pushState('.back-to-index','',href);
							document.title = title;							
						},
						error: function(){
							window.location = href;
						}						   
					});
				// }else{
				// 	setTimeout(function(){
				// 		index.style.display='block';
				// 		featuredProjectsPadding();
				// 		$('body').removeClass('doingajax closing-project');
				// 	},1500);
				// }	

				var projectsTitle = $('#all-projects').length ? 'Projects All  |  Sibling' : 'Projects  |  Sibling';
				window.history.pushState('.back-to-index','',href);
				document.title = projectsTitle;						
	
			// }else{	

			// 	$.ajax({
			// 	    url: href,
			// 	    datatype: "html",
			// 	    success: function(data){

			// 			var parser = new DOMParser();
			// 			var doc = parser.parseFromString(data, "text/html");
			// 			var projectContent = $(doc).find('#index');
			// 			var newsContent = $(doc).find('#news .section-wrap');
			// 			var studioContent = $(doc).find('#studio .section-wrap');
				
			// 			var d = new Date();
			// 				t = d.getTime() - t;
			// 				t = transitionTime - t;
			// 				t = t > 0 ? t : 0;

			// 			$('#projects').html(projectContent);
			// 			$('#news').html(newsContent);
			// 			$('#studio').html(studioContent);

			// 			setTimeout(function(){
			// 				featuredProjectsPadding();
			// 				$('body').removeClass('doingajax closing-project');
			// 			},t + 500);

			// 			var title = $(data).filter('title').text();
			// 			window.history.pushState('.back-to-index','',href);
			// 			document.title = title;							
			// 		},
			// 		error: function(){
			// 			window.location = href;
			// 		}						   
			// 	});
			// }				
		}
		return false;	
	});	


	

	$(document).on('click','.filters button',function(){
		var filter = $(this).data('category');
		if($('#all-projects-list').length !== 0){
			if($(this).hasClass('active')){
				$(this).removeClass('active');
				$('.projects-list>.project[data-category*="'+filter+'"]').removeClass('highlight');

			}else{
				if($('.filters button.active').length > 0){
					$('.filters button.active').each(function(){
						$(this).removeClass('active');
						$('.projects-list>.project[data-category*="'+$(this).data('category')+'"]').removeClass('highlight');
					});
				}	
				$(this).addClass('active');
				$('.projects-list>.project[data-category*="'+filter+'"]').addClass('highlight');
			}
			// if($('.filters button.active').length > 0){
			// 	$('#all-projects-list').addClass('filtering');
			// }else{
			// 	$('#all-projects-list').removeClass('filtering');			
			// }
		}else{
			// $(this).toggleClass('active');
			// $('#all-projects-grid').fadeTo(300,0,function(){
			// 	$('#all-projects').animate({scrollTop:0},300, function(){
			// 		var $activeFilters = $('.filters button.active');
			// 		if($activeFilters.length > 0){
			// 			$('.filters button.active').each(function(){
			// 				$('.projects-grid>.project-card').hide();
			// 				$('.projects-grid>.project-card[data-category*="'+$(this).data('category')+'"]').show();
			// 			});
			// 		}else{
			// 			$('.projects-grid>.project-card').show();
			// 		}	
			// 		$('#all-projects-grid').fadeTo(300,1);
			// 	});
			// });
			if($(this).hasClass('active')){
				$(this).removeClass('active');
			}else{
				if($('.filters button.active').length > 0){
					$('.filters button.active').each(function(){
						$(this).removeClass('active');
					});
				}	
				$(this).addClass('active');
			}	
			$('#all-projects-grid').fadeTo(300,0,function(){
				$('#all-projects').animate({scrollTop:0},300, function(){
					var $activeFilters = $('.filters button.active');
					if($activeFilters.length > 0){
						$('.filters button.active').each(function(){
							$('.projects-grid>.project-card').hide();
							$('.projects-grid>.project-card[data-category*="'+$(this).data('category')+'"]').show();
						});
					}else{
						$('.projects-grid>.project-card').show();
					}	
					$('#all-projects-grid').fadeTo(300,1);
				});
			});
		}
		Cookies.set('sibling_projects_filters', $('.filters button.active').map(function(){ return $(this).data('category'); }).get().join(','));			
	});

	function getProjectOrderById(orderId, $projectItem){
		var order;
		if(orderId === 'chronological'){
			//tinysort('.projects-list>.project','.status span');
			order = $projectItem.get().sort(function(a,b){
				return $(b).find('.status span').text() - $(a).find('.status span').text();
			});
		}else if(orderId === 'a-z'){			
			//tinysort('.projects-list>.project','.title h3');
			order = $projectItem.get().sort(function(a,b){
				return $(a).find('.project-title').text() > $(b).find('.project-title').text() ? 1 : -1;
			});			
		}else if(orderId === 'large-to-small'){
			//tinysort('.projects-list>.project',{data:'size',order:'desc'});
			order = $projectItem.get().sort(function(a,b){
				return parseFloat($(b).attr('data-size')) - parseFloat($(a).attr('data-size'));
			});
		}else if(orderId === 'small-to-large'){
			//tinysort('.projects-list>.project',{data:'size',order:'asc'});
			order = $projectItem.get().sort(function(a,b){
				return parseFloat($(a).attr('data-size')) - parseFloat($(b).attr('data-size'));
			});
		}else{
			// default/original
			order = $projectItem.get().sort(function(a,b){
				return parseFloat($(a).attr('data-orig')) - parseFloat($(b).attr('data-orig'));
			});
		}
		Cookies.set('sibling_projects_order', orderId);
		return order;
	}

	$(document).on('click','.order button',function(){
		var $projectlist = $('.projects-index');
		var $projectItem = $('.projects-index > .project-item');
		var orderId = 'default';
		if($(this).hasClass('active')){
			$(this).removeClass('active');
		}else{
			$('.order button.active').removeClass('active');
			$(this).addClass('active');
			orderId = $(this).attr('id');
		}
		var order = getProjectOrderById(orderId, $projectItem);
		var animate = $('#all-projects-list').length === 0;

		if(animate){
			$projectlist.stop(true, true).fadeTo(500, 0, function () {
				$projectlist.html(order);
				$projectlist.fadeTo(500, 1);
			});
		}else{
			$projectlist.html(order);
		}
	});
	


	$(document).on('click','.scrollto',function(){
		var $scrollto = $(this);
		var href = $scrollto.attr('href');
		var a = href.substring(href.indexOf('#'));
		var $s = $('#studio-expanded');

		$('.studio-nav .scrollto.active').removeClass('active');
		$('.studio-nav .scrollto[href="'+href+'"]').addClass('active');

		$s.unbind("scroll", currentSection);
        $s.animate({scrollTop:  $s.scrollTop() - $s.offset().top + $(a).offset().top},500,function(){
        	$s.bind("scroll", currentSection);
        });

		window.history.pushState('','',href);

		return false;
	});

	$(document).on('click','.person .header',function(){
		if($(this).hasClass('open')){
			$(this).removeClass('open').addClass('opened').next().slideUp();
		}else{
			$(this).addClass('open').next().slideDown();
		}
	});	
	$(document).on('mouseleave','.person .header.opened',function(){
		$(this).removeClass('opened');
	}); 



	$(document).on('click','.projects-container.open .open-filters',function(){
		$('#all-projects').toggleClass('filters-open');
	}); 

	$(document).on('click','.news-container.open .open-filters',function(){
		$('#news').toggleClass('filters-open');
	}); 

	$(document).on('click','.projects-container.closed .open-filters',function(){
		$('#projects .open-section').trigger('click');
	}); 

	$(document).on('click','.section.open #all-news, #studio.section.open .open-section',function(e){
		e.preventDefault();
		$('.section.open .content').animate({scrollTop:0},300);
	});

	// $(document).on('click','#projects.section.open .open-section',function(e){
	// 	e.preventDefault();
	// 	if(!$('body').hasClass('doingajax')){

	// 		$('body').addClass('doingajax');

			
	// 		var $this = $(this);
	// 		var href = $this.attr('href');
	// 		var open = '#' + $('section.open').attr('id');
	// 		var section = '#' + $(this).closest('section.section').attr('id');
	// 		var d = new Date();
	// 		var t = d.getTime();

	
	// 		$.ajax({
	// 		    url: href,
	// 		    datatype: "html",
	// 		    success: function(data){

	// 				var parser = new DOMParser();
	// 				var doc = parser.parseFromString(data, "text/html");
	// 				var docClass = doc.body.getAttribute('class');			
	// 				var d = new Date();
	// 					t = d.getTime() - t;
	// 					t = transitionTime - t;
	// 					t = t > 0 ? t : 0;

	// 				// if($('body').hasClass('font-loaded')){
	// 				// 	docClass += ' font-loaded';
	// 				// }

	// 				setTimeout(function(){

	// 					if(open !== '#projects'){
	// 						var compressedContent = $(doc).find(open + ' .section-wrap > *');
	// 						$(open + ' .section-wrap').html(compressedContent);
	// 					}

	// 					// if(open === '#studio' && $('#shop-wrap').length){
	// 					// 	window.console.log('closing shop');
	// 					// }

	// 					//console.log(section, href, $(doc).find(section + ' .content'));

	// 					if(section !== '#projects'){
	// 						var expandedContent = $(doc).find(section + ' .content');
	// 						$(section + ' .ajaxwrap').html(expandedContent);
	// 					}

	// 					$('.section').not(section).each(function(){
	// 						if($(this).find('.content').length < 1){
	// 							var sectionId = '#' + $(this).attr('id');
	// 							//window.console.log(sectionId);
	// 							var content = $(doc).find(sectionId + ' .content');
	// 							$(sectionId + ' .ajaxwrap').html(content);								
	// 						}
	// 					});

	// 					if($('#project-wrap').length){
	// 						var index = document.getElementById('index');
	// 						if(index){
	// 							$('#project-wrap').fadeOut(function(){
	// 								$(this).remove();
	// 								$('#index').show();
	// 							});
	// 						}else{
	// 							var projectContent = $(doc).find('#index');

	// 							$('#projects').html(projectContent);
	// 							////safariAjaxImgs(projectContent);
								
	// 						}
	// 						$('body').removeClass('closing-project');							
	// 					}



	// 					//$('body').removeClass('doingajax');
	// 					document.body.className = docClass;
	// 					$(open).removeClass('closing').addClass('closed');
	// 					$(section).removeClass('opening closed');


	// 				},t);

	// 				var title = $(data).filter('title').text();
	// 		    	window.history.pushState('.open-section','',href);
	// 				document.title = title;					
	// 			},
	// 			error: function(){
	// 				window.location = href;
	// 			}						   
	// 		});

			
	// 	}	
	// });

	// Shop //
	$(document).on('click','.open-shop-link',function(){
		if(!$('body').hasClass('doingajax')){

			var href = $(this).attr('href');
			var d = new Date();
			var t = d.getTime();

			$('body').addClass('doingajax opening-shop shop');

			// for mobile //
			//$('body').removeClass('home').addClass('intro-closed');
			$('body').removeClass('home');

			$('#news,#projects').removeClass('open');
			//$('#studio').addClass('open');
			//$('#studio').addClass('closing');	

			$.ajax({
			    url: href,
			    datatype: "html",
			    success: function(data){

					var parser = new DOMParser();
					var doc = parser.parseFromString(data, "text/html");
					var docClass = doc.body.getAttribute('class');
					var shopContent = $(doc).find('#studio .section-wrap');
					if($('body').hasClass('font-loaded')){
						docClass += ' font-loaded';
					}
			
					var d = new Date();
						t = d.getTime() - t;
						t = transitionTime - t;
						t = t > 0 ? t : 0;
					//$('#studio .section-wrap').hide();
					$('#studio').addClass('open').html(shopContent);
					//safariAjaxImgs(projectContent);

					setTimeout(function(){
						$('body').removeClass('doingajax opening-shop');
						$('#studio').removeClass('closing');
						document.body.className = docClass;
					},t);

					var title = $(data).filter('title').text();
					window.history.pushState('.open-shop-link','',href);
					document.title = title;	

				},
				error: function(){
					window.location = href;
				}						   
			});
		}
		return false;	
	});	

	$(document).on('click','.back-to-studio',function(){
		if(!$('body').hasClass('doingajax')){

			$('body').addClass('doingajax closing-shop');
			
			var href = $(this).attr('href');
			//var hrefPaged = href;
			// var newsPage = sessionStorage.getItem("newsPage");
			// if(newsPage !== null && newsPage > 1){
			// 	hrefPaged = href + '?excerpts-paged=' + newsPage; 				
			// }
			// $('#shop-wrap').fadeOut(function(){
			// 	$(this).remove();
			// 	$('#index').show();
			$('body').removeClass('shop single-shop');
			// 	$('#studio').addClass('open');
			// });	
				
			var d = new Date();
			var t = d.getTime();

			$.ajax({
			    url: href,
			    datatype: "html",
			    success: function(data){

					var parser = new DOMParser();
					var doc = parser.parseFromString(data, "text/html");
					var docClass = doc.body.getAttribute('class');
					if($('body').hasClass('font-loaded')){
						docClass += ' font-loaded';
					}					
					var projectContent = $(doc).find('#index');
					var newsContent = $(doc).find('#news .section-wrap');
					var studioContent = $(doc).find('#studio .section-wrap');
			
					var d = new Date();
						t = d.getTime() - t;
						t = transitionTime - t;
						t = t > 0 ? t : 10;

					$('#projects').html(projectContent);
					$('#news').html(newsContent);
					$('#studio').html(studioContent);

					setTimeout(function(){
						document.body.className = docClass;
						featuredProjectsPadding();
					},t + 300);

					var title = $(data).filter('title').text();
					window.history.pushState('.back-to-studio','',href);
					document.title = title;							
				},
				error: function(){
					window.location = href;
				}						   
			});
			//}				
		}
		return false;	
	});

	
	function getParameterByName(name, url) {
	    if (!url) url = window.location.href;
	    name = name.replace(/[\[\]]/g, '\\$&');
	    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
	        results = regex.exec(url);
	    if (!results) return null;
	    if (!results[2]) return '';
	    return decodeURIComponent(results[2].replace(/\+/g, ' '));
	}


	$(document).on('click','.news-pagination a',function(e){
		e.preventDefault();
		if(!$('body').hasClass('loadingnews')){

			var href = $(this).attr('href');
			var $news = $('#news');
			var d = new Date();
			var t = d.getTime();
			var page = 1;
			if($news.hasClass('open')){
				if(getParameterByName('excerpts-paged',href)){
					page = getParameterByName('excerpts-paged',href);
				}
			}else{		
				if(href.indexOf('/page/')){
						page = href.split("/page/")[1].match(/^\d*/)[0];
				}
			}

			//if(page > 1){
		    	Cookies.set('sibling_news_page', page);
			// }else{
			// 	Cookies.remove('sibling_news_page');
			// }

			$('body').addClass('loadingnews');

			$.ajax({
			    url: href,
			    datatype: "html",
			    success: function(data){

					var parser = new DOMParser();
					var doc = parser.parseFromString(data, "text/html");			
					var d = new Date();
						t = d.getTime() - t;
						t = transitionTime - t;
						t = t > 0 ? t : 0;

					var newsContent = $(doc).find('#news .news-posts');

					setTimeout(function(){
											
						$news.find('.news-posts-container').html(newsContent);
						$('body').removeClass('loadingnews');

						$('#all-news').attr('href',sitevars.homeurl + '/news/page/' + page);
					},t);

					if($('#news').hasClass('open')){
						// var title = $(data).filter('title').text();
						window.history.pushState({path:href},'',href);
						// document.title = title;
					}	
					Cookies.set('sibling_news_url', href);
				},
				error: function(){
					window.location = href;
				}						   
			});
			
		}
		return false;	
	});




	// News filters //
	$(document).on('click','.news-container.closed .open-filters',function(){
		$('#news .open-section').trigger('click');
	}); 

	$(document).on('click','.news-filters a',function(e){
		e.preventDefault();

		if(!$('body').hasClass('loadingnews')){

			var href = $(this).attr('href');
			var $news = $('#news');
			var d = new Date();
			var t = d.getTime();
			var page = 1;
			if($news.hasClass('open')){
				if(getParameterByName('excerpts-paged',href)){
					page = getParameterByName('excerpts-paged',href);
				}
			}else{		
				if(href.indexOf('/page/')){
					page = href.split("/page/")[1].match(/^\d*/)[0];
				}
			}

			//if(page > 1){
		    	Cookies.set('sibling_news_page', page);
			// }else{
			// 	Cookies.remove('sibling_news_page');
			// }
			$(this).closest('ul').find('.active').removeClass('active');
			$(this).addClass('active');

			$('body').addClass('filteringnews');

			$('#news-expanded').animate({
				scrollTop: 0
			});
	
			$.ajax({
				url: href,
				datatype: "html",
				success: function(data){

					var parser = new DOMParser();
					var doc = parser.parseFromString(data, "text/html");			
					var d = new Date();
						t = d.getTime() - t;
						t = transitionTime - t;
						t = t > 0 ? t : 0;

					var newsContent = $(doc).find('#news .content');

					setTimeout(function(){
											
						$news.find('.ajaxwrap').html(newsContent);
						$('body').removeClass('filteringnews');

						$('#all-news').attr('href',sitevars.homeurl + '/news/page/' + page);
					},t);

					if($('#news').hasClass('open')){
						// var title = $(data).filter('title').text();
						window.history.pushState({path:href},'',href);
						// document.title = title;
					}	
					
					Cookies.set('sibling_news_url', href);
				},
				error: function(){
					window.location = href;
				}						   
			});
	
			
		}
		return false;	
	});



	$(document).on('click','.permalink',function(){
		var $temp = $("<input style='font-size:16px'>");
		$("body").append($temp);
		$temp.val($(this).attr('href')).select();
		document.execCommand("copy");
		$temp.remove();

		$(this).after('<span id="copied" class="copied">Copied</span>');
		setTimeout(function(){
			$('#copied').fadeOut(function(){
				$(this).remove();
			});
		},1000);
		return false;
	});	

	function shopSlider(){
		var $productSlider = $('#product-slider');
		if($productSlider.length){
			var $productSliderCaption = $('#product-slider-caption');
			var $productSliderCount = $('#product-slider-count');


			$productSlider.on('init reInit afterChange', function(event, slick, currentSlide){
			    var i = (currentSlide ? currentSlide : 0) + 1;
			    var caption = $(slick.$slides.get(currentSlide)).find('img').attr('data-caption');
			    if(caption.length){
			    	caption = " " + caption;
			    }

				$productSliderCount.text(i + '/' + slick.slideCount);
				$productSliderCaption.html(caption);
			});

			$productSlider.slick({
				//lazyLoad: 'ondemand',
				//arrows:false,
				fade:true
				//nextArrow: '<button class="slick-next"><svg viewBox="0 0 42 25.5"><polygon points="29.3,0 27.9,1.5 38.2,11.8 0,11.8 0,13.8 38.2,13.8 27.9,24.1 29.3,25.5 42,12.8 "/></svg></button>',
				//prevArrow: '<button class="slick-prev"><svg viewBox="0 0 42 25.5"><polygon points="12.7,25.5 14.1,24 3.8,13.7 42,13.7 42,11.7 3.8,11.7 14.1,1.4 12.7,0 0,12.7 "/></svg></button>'			
				//pauseOnHover:false,
				//pauseOnFocus:false,		
			});
		}
	}
	shopSlider();

	function textareaResize(){
		$('textarea').on('input', function () {
			this.style.height = 'auto';
			this.style.height = (this.scrollHeight) + 'px';
		});	
	}
	textareaResize();	


	$(document).on('click','.accordion-header',function(){
		if($(this).hasClass('open')){
			$(this).removeClass('open').next().slideUp();
		}else{
			$(this).addClass('open').next().slideDown();
		}
	});	

	var $form = $('#product-enquiry-form');

	$form.submit(function(e) {
		e.preventDefault();
		var $submitButton = $form.find('button[type="submit"]');
		var formData = $form.serialize();
		var $formMsg = $('#form-msg');

		$submitButton.addClass('sending').prop( 'disabled', true );

		$.ajax({
			method: "POST",
			url: sitevars.ajaxurl,
			data: formData
		})
		.done(function(data) {
			// Make sure that the formMessages div has the 'success' class.
			$form.removeClass('error').addClass('success');
			$formMsg.html(data.data);
			$formMsg.slideDown();

			setTimeout(function(){
				$form[0].reset();
				$form.removeClass('success');
				$formMsg.slideUp();
			},4000);
			// Clear the form.
			// $('#name').val('');
			// $('#email').val('');
			// $('#message').val('');

			$submitButton.removeClass('sending').prop( 'disabled', false);
		})
		.fail(function(data) {
			// Make sure that the formMessages div has the 'error' class.
			$form.removeClass('success').addClass('error');

			// Set the message text.
			if (data.responseText !== '') {
				$formMsg.text(data.responseText);
			} else {
				$formMsg.text('Oops! An error occured and your message could not be sent.');
			}

			$formMsg.slideDown();

			$submitButton.removeClass('sending').prop( 'disabled', false);
		});



	});


	$(document).on('click','.shop-link',function(){
		if(!$('body').hasClass('doingajax')){

			$('body').addClass('doingajax changing-shop-view');
			
			var href = $(this).attr('href');
				
				var d = new Date();
				var t = d.getTime();

				$.ajax({
				    url: href,
				    datatype: "html",
				    success: function(data){

						var parser = new DOMParser();
						var doc = parser.parseFromString(data, "text/html");
						var shopContent = $(doc).find('#studio .section-wrap');
				
						var d = new Date();
							t = d.getTime() - t;
							t = transitionTime - t;
							t = t > 0 ? t : 10;


						setTimeout(function(){
							//$('#shop-wrap').find('.ajaxwrap').html(shopContent);
							$('#studio').html(shopContent);
							shopSlider();
							textareaResize();	
							$('body').removeClass('doingajax changing-shop-view');
						},t + 300);

						var title = $(data).filter('title').text();
						window.history.pushState('','',href);
						document.title = title;							
					},
					error: function(){
						window.location = href;
					}						   
				});
			//}				
		}
		return false;	
	});	



	// brower back button // 
	//$(window).on('popstate',function() {
  	window.addEventListener('popstate', function(e){
    	
    	var linkSelector = e.state;
		var href = document.location.href;

		//window.console.log(linkSelector,href);

		if($(linkSelector+'[href="'+href+'"]').length){
			$(linkSelector+'[href="'+href+'"]').trigger('click');
		}else{
			//window.console.log('no link');
			window.location = href;

		}
	});	


	// 404 //



	function fourofour(){
		if($('.four-o-four').length){
			$('.four-o-four').each(function(){
				var $el = $(this);
				var $container = $el.closest('.content');
				if (!$container.length) {
					$container = $el.parent();
				}
				$container.css({ position: 'relative', overflow: 'hidden' });
				$el.css({ position: 'absolute' });
				$el.marqueeify({
					speed: 200,
					container: $container
				});	
			});
		}	
	}
	fourofour();


});	